export default class MediaAttribute {
  constructor(
    width,
    height,
    bitrate
  ) {
    this.width = width;
    this.height = height;
    this.bitrate = bitrate;
    Object.freeze(this);
  }

  static invalid() {
    return new MediaAttribute(-1, -1, -1);
  }
}
